import { z } from "zod";
import { type ParserType, parser } from "../parser.js";
import { Tags } from "../tag.js";

export type QueryTagsResponse = ParserType<typeof QueryTagsResponse>;
export const QueryTagsResponse = parser(
  z.strictObject({
    tags: Tags.schema,
  }),
);
